var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopyright(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "copyright",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_361",
    "data-name": "Group 361"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_360",
    "data-name": "Group 360"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M155.576,146.955a2.5,2.5,0,0,1,.285-.826,1.652,1.652,0,0,1,.561-.584,1.632,1.632,0,0,1,.85-.219,1.59,1.59,0,0,1,.617.124,1.5,1.5,0,0,1,.812.845,1.852,1.852,0,0,1,.128.608h1.7a3.4,3.4,0,0,0-.261-1.226,2.843,2.843,0,0,0-.67-.959,2.943,2.943,0,0,0-1.026-.622,3.8,3.8,0,0,0-1.325-.223,3.761,3.761,0,0,0-1.61.318,3.211,3.211,0,0,0-1.14.874,3.674,3.674,0,0,0-.679,1.287,5.361,5.361,0,0,0-.219,1.553v.261a5.371,5.371,0,0,0,.223,1.558,3.612,3.612,0,0,0,.679,1.283,3.23,3.23,0,0,0,1.145.869,3.8,3.8,0,0,0,1.615.318,3.516,3.516,0,0,0,1.254-.219,3.344,3.344,0,0,0,1.026-.6,2.9,2.9,0,0,0,.7-.893,2.627,2.627,0,0,0,.285-1.092h-1.7a1.353,1.353,0,0,1-.143.551,1.328,1.328,0,0,1-.342.432,1.6,1.6,0,0,1-.5.28,1.757,1.757,0,0,1-.575.095,1.657,1.657,0,0,1-.85-.223,1.677,1.677,0,0,1-.565-.589,2.492,2.492,0,0,1-.285-.831,5.6,5.6,0,0,1-.071-.936V147.9A5.7,5.7,0,0,1,155.576,146.955Z",
    transform: "translate(-147.9 -138.533)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M9.5,0A9.5,9.5,0,1,0,19,9.5,9.5,9.5,0,0,0,9.5,0Zm0,17.1a7.6,7.6,0,1,1,7.6-7.6A7.61,7.61,0,0,1,9.5,17.1Z",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyright);
export default __webpack_public_path__ + "static/media/copyright.fe469c930e98317cc601833f2f7498f1.svg";
export { ForwardRef as ReactComponent };